import login from './login'
import result from './result'

const enrollQuery = {
  path: 'enroll_query',
  component: resolve => require(['../../../../../pages/portal/sbs/training/enroll-query'], resolve),
  children: [
    login,
    result
  ]
}

export default enrollQuery
